module.exports = __webpack_public_path__ + "img/navbar-4.4084392b.svg";